import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import NavigateLink from '../../../shared/components/features/navigateLink/navigateLink';
import Popup from '../../../shared/components/ui/popup/Popup';
import Text from '../../../shared/components/features/text/Text';
import HeaderPopup from '../../../shared/components/ui/popup/headerPopup/HeaderPopup';
import ContentsPopup from '../../../shared/components/ui/popup/contentPopup/ContentPopup';

const NotAuthButton = ({ text, link, icon, className, newTab, checkLogin, popup, showLoadingPage = false, onClick }) => {

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { lang, texts } = useSelector(state => state.translate);
    const resolvedLink = link?.replace('<lang>', lang);

    return (
        <>
            <NavigateLink link={resolvedLink} asElement="button" className={className} checkLogin={checkLogin} showLoadingPage={showLoadingPage} target={newTab ? "_blank" : "_self"} onClick={onClick}>
                <Text>{texts[text]}</Text>
                {icon && <img src={icon} alt={texts[text]} />}
            </NavigateLink>

            {isPopupOpen &&
                <Popup close={() => setIsPopupOpen(false)} title={texts[popup.title]} accessibilityDescription={texts[popup.title]}>
                    <HeaderPopup>
                        <Text>{texts[popup.title]}</Text>
                    </HeaderPopup>
                    <ContentsPopup>
                        {popup.image && <img src={popup.image} alt="" />}
                        {texts[popup.description]}
                    </ContentsPopup>
                </Popup>
            }
        </>
    );
};

export default NotAuthButton;
